// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { ProductDetailResponse } from "../../types/ProductDetailResponse";

import { PayloadAction } from "@reduxjs/toolkit";
import {
  modBookingState,
  product2BookingAttributes,
} from "../../utils/bookingUtils";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
import { deepCopy } from "../../utils/common";
import dayjs from "dayjs";

export const bookingSliceBody = {
  initialState: {
    product: undefined,
    bookingAttributes: [],
    childrenLs: [],
    month: dayjs().format("YYYY-MM"),
  } as BookingState & { month: string },
  reducers: {
    captureProductData: (
      state: BookingState,
      action: PayloadAction<{
        product: ProductDetailResponse;
        oldState?: BookingState | null;
      }>,
    ) => {
      state.product = action.payload.product;
      state.canceledProductIds = action.payload.oldState?.canceledProductIds;
      state.prevBookingState = action.payload.oldState?.prevBookingState;
      state.childrenLsFull = action.payload.oldState?.childrenLsFull ?? [];
      state.bookingAttributes = product2BookingAttributes(action.payload);
      if (action.payload.oldState?.childrenLs) {
        state.childrenLs = deepCopy(action.payload.oldState?.childrenLs);
      } else {
        state.childrenLs = [];
      }
      if (action.payload.oldState?.id) {
        state.id = action.payload.oldState?.id;
      }
    },
    resetBooking: (state: BookingState) => {
      for (const child of state.bookingAttributes) {
        child.value = undefined;
      }
      state.childrenLs = [];
    },
    bookingPick: (
      state: BookingState,
      action: PayloadAction<BookingAttributeDTO>,
    ) => {
      modBookingState(state, action.payload);
    },
    bookingPickLs: (
      state: BookingState,
      action: PayloadAction<BookingAttributeDTO[]>,
    ) => {
      for (const pl of action.payload) {
        modBookingState(state, pl);
      }
    },
    replaceBookingAttributes: (
      state: BookingState,
      action: PayloadAction<BookingAttributeDTO[]>,
    ) => {
      state.bookingAttributes = action.payload;
    },
    clear: (state: BookingState) => {
      state = {
        product: undefined,
        bookingAttributes: [],
        childrenLs: [],
      };
    },
    selectChildProduct: (
      state: BookingState,
      action: PayloadAction<BookingState>,
    ) => {
      console.log("Old booking state: ", deepCopy(state));
      const payload = deepCopy(action.payload);
      const childrenLs = deepCopy(state.childrenLs ?? []);
      // nếu là pass thì cập nhật số lượng cho từng loại product
      const def = ProdAttrUtils.PASS.findDefaultBooka(state.bookingAttributes);

      if (def) {
        const ageQuantities = def?.value?.ageQuantities ?? [];
        payload.bookingAttributes = ProdAttrUtils.PASS.applyQuantityOfChildren(
          payload.bookingAttributes,
          ageQuantities,
        );
      }

      const index = childrenLs.findIndex(
        (v) => v.product?.id === payload.product?.id,
      );
      if (index === -1) {
        childrenLs.push(payload);
      } else {
        childrenLs[index] = {
          ...payload,
          canEdit: childrenLs[index].canEdit ?? false,
          canCancel: childrenLs[index].canCancel ?? false,
        };
      }
      state.childrenLs = childrenLs;
      console.log("New booking state: ", deepCopy(state));
    },
    deSelectChildProducts: (
      state: BookingState,
      action: PayloadAction<{ productIds: number[] }>,
    ) => {
      const childrenLs = deepCopy(state.childrenLs ?? []);
      for (const id of action.payload.productIds) {
        const index = childrenLs.findIndex((v) => v.product?.id === id);
        if (index !== -1) {
          childrenLs.splice(index, 1);
        }
      }

      state.childrenLs = childrenLs;
      console.log("New booking state: ", deepCopy(state));
    },
    selectMonth: (
      state: BookingState & { month: string },
      action: PayloadAction<{ month: string }>,
    ) => {
      state.month = action.payload.month;
    },
  },
};
